export default __webpack_public_path__ + "static/media/TimerIcon.498a81cd.svg";